import clsx from 'clsx'
import { Col, Row } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Finance/Wallets/subcomponents/HistoryList/HistoryList.module.scss'
import Money from 'modules/Finance/Wallets/subcomponents/Money'
import StatusIcon from 'modules/Finance/Wallets/subcomponents/PromisedPayments/subcomponents/StatusIcon'
import { useTranslation } from 'react-i18next'

const PaymentRow = ({ amount = '', currency = '', status = '', id }) => {
  const { t } = useTranslation(['wallets'])

  const heading = useMemo(
    () =>
      t(`promised_payment.row_header`, {
        id,
      }),
    [id, t],
  )

  const breakpoints = useBreakpoint()

  return (
    <Row className={styles['history-list__row']}>
      <Col s="auto" sm="auto" xs="auto" className={styles['history-list__col']}>
        <div className={clsx(styles['history-list__badge'])}>
          <StatusIcon status={status} breakpoints={breakpoints} />
        </div>
      </Col>
      <Col className={styles['history-list__col']} fluid>
        <div className={styles['history-list__heading']} title={heading}>
          {heading}
        </div>
        <div className={styles['history-list__action']}>
          {t(`promised_payment.status.${status}`)}
        </div>
      </Col>
      <Col s="4" xs="4" className={styles['history-list__col']}>
        <div className={clsx(styles['history-list__cost'])}>
          <Money number={amount} currency={currency} status={status} />
        </div>
      </Col>
    </Row>
  )
}

export default PaymentRow

PaymentRow.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
  action: PropTypes.string,
  heading: PropTypes.string,
  status: PropTypes.oneOf(['pending', 'approved', 'declined', 'repaid']),
  id: PropTypes.number,
}
